import * as $ from "jquery";
import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";
import { ContactMethodDataProvider } from "../../data-provider/contact-method.dp";
import { EmploymentStatusDataProvider } from "../../data-provider/employment-status.dp";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { ElectionDataProvider } from "../../data-provider/election.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Effort } from "../../models/effort.model";
import { Field } from "../../models/field.model";
import { Filter } from "../../models/filter.model";
import { Group } from "../../models/group.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { FilterService } from "../../services/filter.service";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { HouseService } from "../../services/house.service";
import { SurveyService } from "../../services/survey.service";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { SearchUtils } from "../../helper/search.helper";
import {
    creditRatings,
    householdNetWorths,
} from "../../utils/constants/fields.constants";
import { filterHeaders } from "../../utils/constants/filters.constants";
import { Team } from "../../models/team.model";

let FilterPane = {
    selector: "vcFilterPane",
    templateUrl: "/angular/components/filter/filter-pane.component.html",
    bindings: {
        injectedFilter: "=",
        updateUrl: "=?",
        activeTab: "=?",
        readOnly: "=?",
    },
    controller: class FilterPaneController {
        // * bindings for typescript compiler *
        public injectedFilter: any;
        public updateUrl?: any;
        public activeTab?: any;
        public readOnly?: any;
        // ************************************

        public readonly filterDynamicFields = [
            "gender",
            "party",
            "deceased",
            "donor",
            "employment",
            "volunteer",
            "email",
            "homephone",
            "mobilephone",
            "credit_rating",
            "income",
            "donor_environmental",
        ];
        public defaultFilter: Filter;
        public filterHeaders: any = filterHeaders;
        public creditRatings: string[] = creditRatings;
        public householdNetWorths: string[] = householdNetWorths;
        public canvassFilters: Filter;
        public lastInteractedTemplates: any[] = [];

        public canvassers: User[] = [];
        public teams: Team[] = [];
        public elections: any[] | undefined = undefined;
        public firstLoad = true;
        public ages: number[] = [];
        public limitLow: number | undefined;
        public limitHigh: number | undefined;
        public fname = "Filters";
        public selectedFilter: Filter;
        public filter: any;
        public filters: Filter[] | null = null;
        public appliedFilter: Filter;
        public injectedFilterCopy: any;
        public selectedUsers: User[] = [];
        public isLeaderView = false;
        public consentTypes: any;
        public activeCampaign: Campaign;
        public customFields: Field[] = [];
        public efforts: Effort[] = [];
        public app_types: string[];
        public campaigns: Campaign[] | undefined;
        public divisions: Division[] | undefined;
        public loadingCanvassers = true;
        public groups: Group[] = [];
        public canvass_types: any[] = [];
        public loadingCanvassTypes = true;
        public imports = [];
        public totalZipCodesDisplayed = 50;
        public zipcodes: any[] = [];
        public surveys: any[] = [];
        public loadingVoterFiles = false;
        public loadingZips = false;
        public precincts: any[] = [];
        public loadingPrecincts = false;
        public loadingParties = false;
        public loadingContactMethods = false;
        public loadingEmploymentStatuses = false;
        public loadingTeams = false;
        public totalDisplayed = {
            precincts: 50,
            zips: 50,
        };
        public parties: any[] = [];
        public contactmethods: any[] = [];
        public employmentstatuses: any[] = [];
        public liststatuses: any[] = [
            { key: "Active", value: "In Progress" },
            { key: "Inactive", value: "Inactive" },
            { key: "Done", value: "Archived" },
            { key: "Pending", value: "Pending Approval" },
        ];
        public dynamicFilterFields: any[] = [];
        public emptyFilter: any;
        public groupSearch: string = "";

        private readonly $scope: any;
        private readonly $location: any;
        private readonly $filter: any;
        public readonly __env: any;

        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;
        private readonly employmentStatusDataProvider: EmploymentStatusDataProvider;
        private readonly contactMethodDataProvider: ContactMethodDataProvider;
        private readonly service: FilterService;
        private readonly electionDataProvider: ElectionDataProvider;
        private readonly groupDataProvider: GroupDataProvider;
        private readonly canvassStatusDataProvider: CanvassStatusDataProvider;
        private readonly voterFileDataProvider: VoterFileDataProvider;
        private readonly houseService: HouseService;
        private readonly surveyService: SurveyService;
        private readonly surveyDataProvider: SurveyDataProvider;
        private readonly userDataProvider: UserDataProvider;
        private readonly teamDataProvider: TeamDataProvider;
        private readonly houseOccupantResource: HouseOccupantService;
        private readonly navigationBarService: NavigationBarHelperService;
        private readonly searchUtils: SearchUtils;
        private readonly effortDataProvider: EffortDataProvider;
        private readonly resultDataProvider: ResultDataProvider;

        public dataProvider: FilterDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $location: any,
            $filter: any,
            __env: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            EmploymentStatusDataProvider: EmploymentStatusDataProvider,
            FieldDataProvider: FieldDataProvider,
            ContactMethodDataProvider: ContactMethodDataProvider,
            FilterService: FilterService,
            FilterDataProvider: FilterDataProvider,
            ElectionDataProvider: ElectionDataProvider,
            GroupDataProvider: GroupDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            VoterFileDataProvider: VoterFileDataProvider,
            HouseService: HouseService,
            SurveyService: SurveyService,
            SurveyDataProvider: SurveyDataProvider,
            UserDataProvider: UserDataProvider,
            TeamDataProvider: TeamDataProvider,
            HouseOccupantService: HouseOccupantService,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            PermissionCheck: PermissionCheck,
            SearchUtils: SearchUtils,
            CampaignDataProvider: CampaignDataProvider,
            EffortDataProvider: EffortDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            ResultDataProvider: ResultDataProvider
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.$filter = $filter;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.employmentStatusDataProvider = EmploymentStatusDataProvider;
            this.contactMethodDataProvider = ContactMethodDataProvider;
            this.service = FilterService;
            this.dataProvider = FilterDataProvider;
            this.electionDataProvider = ElectionDataProvider;
            this.groupDataProvider = GroupDataProvider;
            this.canvassStatusDataProvider = CanvassStatusDataProvider;
            this.voterFileDataProvider = VoterFileDataProvider;
            this.houseService = HouseService;
            this.surveyService = SurveyService;
            this.surveyDataProvider = SurveyDataProvider;
            this.userDataProvider = UserDataProvider;
            this.teamDataProvider = TeamDataProvider;
            this.houseOccupantResource = HouseOccupantService;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;
            this.searchUtils = SearchUtils;
            this.effortDataProvider = EffortDataProvider;
            this.resultDataProvider = ResultDataProvider;

            this.isLeaderView = __app_type == "LEADER";
            this.setUpDefaultProperties();
            this.activeCampaign = CampaignDataProvider.activeCampaign;

            ConsentTypeDataProvider.all().then((consentTypes: any) => {
                this.consentTypes = consentTypes;
            });

            if (this.isLeaderView) {
                DivisionDataProvider.getAllDivisions().then(
                    (divisions: Division[]) => {
                        this.divisions = divisions;
                    }
                );

                CampaignDataProvider.allCampaigns(true).then(
                    (campaigns: Campaign[]) => {
                        this.campaigns = campaigns;
                    }
                );
            }

            FieldDataProvider.getCustomFields().then(
                (customFields: Field[]) => {
                    this.customFields = customFields;
                }
            );

            FieldDataProvider.getAllFields().then((fields: any) => {
                this.dynamicFilterFields = [
                    ...fields.priority,
                    ...fields.nonpriority,
                    ...fields.priorityDisabled,
                ].filter(
                    (field: Field) =>
                        this.filterDynamicFields.indexOf(field.hokey) > -1
                );
            });
        }

        $onInit() {
            if (this.readOnly && this.injectedFilter) {
                this.filter = _.cloneDeep(this.injectedFilter);
                this.appliedFilter = _.cloneDeep(this.injectedFilter);
            } else {
                this.filter = this.dataProvider.filter;
                this.appliedFilter = this.dataProvider.appliedFilter;
            }

            this.injectedFilterCopy = _.cloneDeep(this.injectedFilter);

            if (angular.isUndefined(this.updateUrl)) {
                this.updateUrl = true;
            }

            if (this.injectedFilter) {
                _.merge(this.defaultFilter, _.cloneDeep(this.injectedFilter));
            }

            this.permissionProvider.hasFeature("GO_APP").then(() => {
                if (this.activeTab === "people") {
                    this.loadAppTypeFilter();
                } else {
                    this.setFilters(this.defaultFilter);
                }
            });

            if (angular.isUndefined(this.canvassers)) {
                this.loadCanvassers();
            }
            this.setElections();

            this.surveyDataProvider.getAllSurveys().then((surveys: any[]) => {
                this.surveys = surveys;

                if (this.readOnly) {
                    angular.forEach(this.filter.surveys, (survey: any) => {
                        this.toggleSurveyChecked(survey);
                    });
                }
            });

            this.setAges();

            this.$scope.$on("$mdMenuOpen", () => {
                if (!this.filters) {
                    this.filters = [];
                    this.service.all().then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.filters = json.data;
                        }
                    });
                }
            });

            this.filter.setData(
                _.merge(this.defaultFilter, this.previousFilter())
            );

            this.canvassStatusDataProvider
                .walkCanvassStatuses()
                .then((statuses: any) => {
                    this.loadingCanvassTypes = false;
                    this.canvass_types = statuses;
                });

            this.setUpWatcher();
        }

        setUpWatcher(): void {
            this.$scope.$watch(
                () => this.activeTab,
                (newValue: string) => {
                    if (newValue === "people") {
                        this.loadAppTypeFilter();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.group.checked,
                (newValue: boolean) => {
                    if (newValue && !this.groups.length) {
                        this.groupDataProvider
                            .getAllGroups()
                            .then((groups: Group[]) => {
                                this.groups = groups;
                            });
                    }
                },
                true
            );

            this.$scope.$watch(
                () => `${this.groups.length}`,
                (newValue: string, oldValue: string) => {
                    if (newValue && newValue < oldValue) {
                        const groupsTmp = this.filter.group;
                        if (groupsTmp.checked && groupsTmp.values.length > 0) {
                            const newGroups = this.groups.map(
                                (grp: Group) => grp.gid
                            );
                            const found = groupsTmp.values.filter(
                                (g: string) => newGroups.indexOf(g) > 1
                            );
                            if (groupsTmp.values.length > found.length) {
                                this.filter.group.values = found;
                                this.applyFilters();
                            }
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.imports.checked,
                (newValue: boolean) => {
                    if (newValue && !this.imports.length) {
                        this.loadVoterFiles();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                () => this.dataProvider.nonEmptyFilters(this.firstLoad),
                true
            );

            this.$scope.$watch(
                () => this.filter.zipcode.checked,
                (newValue: boolean) => {
                    if (newValue && !this.zipcodes.length) {
                        this.loadZipCodes();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.elections.checked,
                (newValue: boolean) => {
                    if (newValue && !this.zipcodes.length) {
                        this.loadZipCodes();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.precinct.checked,
                (newValue: boolean) => {
                    if (newValue && !this.precincts.length) {
                        this.loadPrecincts();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.age.values,
                (newValue: any) => {
                    if (newValue && newValue.length) {
                        if (angular.isDefined(newValue[0].high_num)) {
                            newValue[0].high_num = parseInt(
                                newValue[0].high_num
                            );
                        }
                        if (angular.isDefined(newValue[0].low_num)) {
                            newValue[0].low_num = parseInt(newValue[0].low_num);
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.party.checked,
                (newValue: boolean) => {
                    if (newValue && !this.parties.length) {
                        this.loadParties();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.contact_method.checked,
                (newValue: boolean) => {
                    if (newValue && !this.contactmethods.length) {
                        this.loadContactMethods();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.employment_status.checked,
                (newValue: boolean) => {
                    if (newValue && !this.employmentstatuses.length) {
                        this.loadEmploymentStatuses();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.appliedFilter,
                () => {
                    this.dataProvider.nonEmptyAppliedFilters();
                },
                true
            );

            this.$scope.$watch(
                () => this.filter.search,
                () => this.applyFilters(),
                true
            );

            this.$scope.$watch(
                () => this.filter.efforts,
                () => {
                    angular.forEach(this.filter.efforts, (effort: Effort) => {
                        if (effort.canvasser) {
                            effort.canvasser.values = [];
                            angular.forEach(
                                effort.selectedUsers,
                                (user: User) => {
                                    effort.canvasser.values.push(user.uid);
                                }
                            );
                        }
                    });
                },
                true
            );

            this.$scope.$watch(
                () => this.customFields,
                () => {
                    if (this.customFields && this.customFields.length) {
                        let previousFilters = this.previousFilter();
                        let mergedFields = _.cloneDeep(this.customFields);
                        if (previousFilters.custom_fields) {
                            angular.forEach(
                                previousFilters.custom_fields,
                                (value: any) => {
                                    let fieldToMerge =
                                        this.customFieldFilterWithID(
                                            value.cfid,
                                            mergedFields
                                        );
                                    if (fieldToMerge)
                                        fieldToMerge = angular.extend(
                                            fieldToMerge,
                                            value
                                        );
                                }
                            );
                        }
                        if (this.readOnly) {
                            angular.forEach(
                                this.filter.custom_fields,
                                (filterField: any) => {
                                    angular.forEach(
                                        mergedFields,
                                        (customField: any) => {
                                            if (
                                                customField.cfid ==
                                                filterField.cfid
                                            ) {
                                                _.merge(
                                                    filterField,
                                                    customField
                                                );
                                            }
                                        }
                                    );
                                }
                            );
                        } else {
                            this.filter.custom_fields = _.merge(
                                this.filter.custom_fields,
                                mergedFields
                            );
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.elections,
                (newValue: any, oldValue: any) => {
                    if (newValue && oldValue) {
                        if (newValue.length == oldValue.length) {
                            //no new elections do nothing.
                            return;
                        }
                        this.elections.forEach((value: any) => {
                            let electionField = this.electionFilterWithID(
                                value.elid,
                                this.filter.elections
                            );
                            if (!electionField) {
                                this.filter.elections.push({
                                    elid: value.elid,
                                    values: [],
                                });
                            } else {
                                this.loadElectionValues(value);
                            }
                        });
                    }
                },
                true
            );
        }

        setUpDefaultProperties(): void {
            this.defaultFilter = new Filter({
                location_type: { values: [], checked: false },
                canvassed: { values: [], checked: false },
                custom_fields: [],
                app_type: { values: [], checked: false },
                nationbuilder_import: { values: [], checked: false },
                elections: [],
                imports: { values: [], checked: false },
                efforts: {},
                group: { values: [], checked: false },
                zipcode: { values: [], checked: false },
                precinct: { values: [], checked: false },
                party: { values: [], checked: false },
                age_bracket: { values: [], checked: false },
                age: { values: [], checked: false },
                gender: { values: [], checked: false },
                division: { values: {}, checked: false },
                campaign: { values: [], checked: false },
                volunteer: { values: [], checked: false },
                deceased: { values: [], checked: false },
                donor: { values: [], checked: false },
                email: { values: "", checked: false },
                mobilephone: { values: "", checked: false },
                homephone: { values: "", checked: false },
                contact_method: { values: [], checked: false },
                consenttype: { values: [], checked: false },
                contact_details: { values: [], checked: false },
                employment_status: { values: [], checked: false },
                notes: { values: [], checked: false },
                building: { values: [], checked: false },
                access_type: { values: [], checked: false },
                building_notes: { values: [], checked: false },
                surveys: [],
                search: { values: "", checked: true },
                exclude_unsubs: { checked: false },
                credit_rating: { values: [], checked: false },
                income: { values: {}, checked: false },
                donor_environmental: { values: [], checked: false },
                dwelling_type: { values: [], checked: false },
                homeowner: { values: [], checked: false },
                square_footage: { values: {}, checked: false },
                year_built: { values: {}, checked: false },
                purchase_price: { values: {}, checked: false },
                purchase_year: { values: {}, checked: false },
                net_worth: { values: [], checked: false },
                assigned_users: { values: [], checked: false },
                assigned_teams: { values: [], checked: false },
                list_status: { values: [], checked: false },
            });

            this.canvassFilters = new Filter({
                canvass_type: { values: [], checked: false, match_type: "any" },
                reception: { values: [], checked: false },
                canvasser: { values: [], checked: false, match_type: "any" },
                queried: { values: [], checked: false },
                surveyed: { values: [], checked: false },
                signature: { values: [], checked: false },
                last_interacted: {
                    checked: false,
                    dateStart: null,
                    dateEnd: null,
                    selectedTemplate: null,
                    selectedTemplateName: null,
                },
            });

            this.lastInteractedTemplates =
                this.resultDataProvider.getCustomDateTemplates();
        }

        closeFilterBar(): void {
            this.navigationBarService.setFilterBarOpen(false);
        }

        previousFilter(filter?: Filter): Filter {
            let search = angular.isDefined(filter)
                ? { filter: filter }
                : this.$location.search();
            let reformatted = this.dataProvider.reformatFilter(search);
            if (
                reformatted.custom_fields &&
                reformatted.custom_fields.length > 0
            ) {
                let customFields = _.cloneDeep(this.customFields);
                angular.forEach(
                    reformatted.custom_fields,
                    (selected: Field) => {
                        angular.forEach(customFields, (defaultField: Field) => {
                            if (selected.cfid == defaultField.cfid) {
                                _.merge(defaultField, selected);
                            }
                        });
                    }
                );
                reformatted.custom_fields = customFields;
            }
            return reformatted;
        }

        setEfforts(): void {
            if (!this.isLeaderView) {
                this.effortDataProvider
                    .getAllEfforts()
                    .then((efforts: Effort[]) => {
                        this.efforts = efforts;
                        this.formatEfforts(this.efforts);
                    });
            } else {
                this.efforts = [
                    new Effort({
                        name: "Interaction",
                        datasetid: "1",
                        id: "1",
                        status: "Leader",
                    }),
                ];
                this.formatEfforts(this.efforts);
            }
        }

        setFilters(filters: Filter): void {
            this.emptyFilter = _.cloneDeep(filters);
            this.filter.setData(_.merge(filters, this.previousFilter()));
            this.setEfforts();
            _.merge(this.appliedFilter, _.cloneDeep(this.filter));
        }

        focusZipCodeSearch(): void {
            document.getElementById("zip-code-search").focus();
        }

        loadAppTypeFilter(): void {
            this.app_types = [
                this.$filter("capitalizeEachWord")(
                    this.__env.strings.voter_file
                ),
                "Walk",
                "Go",
                "Salesforce",
                "NationBuilder",
                "Prospector",
            ];
            this.setFilters(this.defaultFilter);
        }

        loadCanvassers(): void {
            this.loadingCanvassers = true;
            this.userDataProvider.getAllUsers().then(
                (users: User[]) => {
                    this.canvassers = users;
                    this.loadingCanvassers = false;
                    if (this.readOnly) {
                        this.sortReadOnlyCanvassers();
                    }
                },
                () => (this.loadingCanvassers = false)
            );
        }

        loadTeams(): void {
            this.loadingTeams = true;
            this.teamDataProvider.getAllTeams().then(
                (teams: Team[]) => {
                    this.teams = teams;
                    this.loadingTeams = false;
                },
                () => (this.loadingTeams = false)
            );
        }

        getType(values: any): string {
            return typeof values;
        }

        setElections(): void {
            if (angular.isUndefined(this.elections)) {
                this.electionDataProvider
                    .getAllElections()
                    .then((elections: any) => {
                        this.elections = elections;

                        if (!this.readOnly) {
                            for (let i = 0; i < this.elections.length; i++) {
                                this.filter.elections[i] = {
                                    elid: this.elections[i].elid,
                                    values: [],
                                };
                            }
                        } else {
                            if (this.readOnly) {
                                angular.forEach(
                                    this.filter.elections,
                                    (filterElection: any) => {
                                        angular.forEach(
                                            this.elections,
                                            (election: any) => {
                                                if (
                                                    filterElection.elid ==
                                                    election.elid
                                                ) {
                                                    election.values =
                                                        filterElection.values;
                                                }
                                            }
                                        );
                                    }
                                );
                            }
                        }
                    });
            }
        }

        formatEfforts(efforts: Effort[]): void {
            if (this.readOnly && this.filter.efforts.values) {
                this.filter.efforts = this.filter.efforts.values;
                this.filter.efforts.checked = true;
            }
            angular.forEach(efforts, (effort: Effort) => {
                if (!this.readOnly) {
                    let effortFilters = _.cloneDeep(this.canvassFilters);
                    effortFilters.checked = this.efforts.length <= 1;
                    this.defaultFilter.efforts["e" + effort.id] = effortFilters;
                    effortFilters.selectedUsers = [];
                    this.filter.efforts["e" + effort.id] = _.merge(
                        effortFilters,
                        this.filter.efforts["e" + effort.id]
                    );
                } else {
                    if (this.filter.efforts["e" + effort.id]) {
                        this.filter.efforts["e" + effort.id].checked = true;
                    }
                }
            });
        }

        sortReadOnlyCanvassers(): void {
            if (this.injectedFilterCopy.efforts) {
                this.injectedFilterCopy.efforts =
                    this.injectedFilterCopy.efforts.values;
                angular.forEach(this.efforts, (effort: Effort) => {
                    if (
                        this.injectedFilterCopy.efforts["e" + effort.id] &&
                        this.injectedFilterCopy.efforts["e" + effort.id]
                            .canvasser
                    ) {
                        this.filter.efforts["e" + effort.id].selectedUsers = [];
                        angular.forEach(
                            this.injectedFilterCopy.efforts["e" + effort.id]
                                .canvasser.values,
                            (uid: string | number) => {
                                angular.forEach(
                                    this.canvassers,
                                    (user: User) => {
                                        if (user.uid == uid) {
                                            this.filter.efforts[
                                                "e" + effort.id
                                            ].selectedUsers.push(user);
                                        }
                                    }
                                );
                            }
                        );
                    }
                });
            }
        }

        loadSurvey(survey: any): void {
            survey.surveyLoading = true;
            this.surveyService.info(survey.sid).then((response: object) => {
                const json = response["data"];
                survey.surveyLoading = false;
                if (!survey.questions) survey.questions = [];
                if (json.success)
                    _.merge(survey.questions, json.data.questions);

                angular.forEach(this.surveys, (survey: any) => {
                    if (survey.sid == json.data.sid) {
                        if (!survey.questions) survey.questions = [];
                        _.merge(survey.questions, json.data.questions);
                    }
                });
            });
        }

        setAges(): void {
            for (let i = 12; i <= 123; i++) {
                this.ages.push(i);
            }
            this.limitLow = this.ages[0];
            this.limitHigh = this.ages[this.ages.length - 1];
        }

        openModalSaveFilter(ev: any): void {
            let confirm = this.dialog
                .prompt()
                .title("Save this filter?")
                .textContent(
                    "If you save this filter you can quickly load it again."
                )
                .placeholder("Filter name")
                .required(true)
                .targetEvent(ev)
                .ok("Save Filter")
                .cancel("Cancel");
            this.dialog
                .showPreConfiguredDialog(confirm)
                .then((filterName: string) => {
                    this.createFilter(
                        new Filter({
                            fname: filterName,
                            filters: this.dataProvider.non_empty_fitlers,
                        })
                    );
                });
        }

        openModalDeleteFilter(ev: any, filter: Filter): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        bodyText: "They will be permanently deleted",
                        title: `Delete Filter?`,
                    },
                })
                .then(() => {
                    this.service
                        .delete({ id: filter.fid })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.filters.splice(
                                    this.filters.indexOf(filter),
                                    1
                                );
                                if (this.selectedFilter.fid == filter.fid) {
                                    this.selectedFilter = null;
                                }
                                this.toast.success("Filter deleted");
                            }
                        });
                });
        }

        createFilter(filter: Filter): void {
            this.service.create(filter).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    json.data.fid = json.id;
                    this.filters.push(json.data);
                    this.selectedFilter = json.data;
                    this.toast.success("Filter saved");
                }
            });
        }

        setFilter(filter: any): void {
            this.clearFilters();
            this.selectedFilter = filter;
            this.defaultFilter = _.cloneDeep(this.emptyFilter);
            this.defaultFilter.custom_fields = this.customFields;

            this.filter.setData(
                _.merge(this.defaultFilter, this.previousFilter(filter.filters))
            );
            this.applyFilters();
        }

        loadVoterFiles(): void {
            this.loadingVoterFiles = true;
            this.voterFileDataProvider.getVoterFiles().then(
                (voterFiles: any) => {
                    this.imports = voterFiles;
                    this.loadingVoterFiles = false;
                },
                () => (this.loadingVoterFiles = false)
            );
        }

        loadZipCodes(): void {
            this.loadingZips = true;
            this.houseService.zipcodes().then((response: object) => {
                const json = response["data"];
                this.loadingZips = false;
                if (json.success) this.zipcodes = json.data;
            });
        }

        loadMore(type: string): void {
            if (type == "zips") this.totalDisplayed.zips += 100;
            else if (type == "precincts") this.totalDisplayed.precincts += 100;
        }

        loadPrecincts(): void {
            this.loadingPrecincts = true;
            this.houseService.precincts().then((response: object) => {
                const json = response["data"];
                this.loadingPrecincts = false;
                if (json.success) this.precincts = json.data;
            });
        }

        loadParties(): void {
            this.loadingParties = true;
            this.houseOccupantResource.parties().then((response: object) => {
                const json = response["data"];
                this.loadingParties = false;
                if (json.success) this.parties = json.data;
            });
        }

        loadContactMethods(): void {
            this.loadingContactMethods = true;
            this.contactMethodDataProvider.all().then((contactMethods: any) => {
                this.loadingContactMethods = false;
                this.contactmethods = contactMethods;
            });
        }

        loadEmploymentStatuses(): void {
            this.loadingEmploymentStatuses = true;
            this.employmentStatusDataProvider.all().then((statuses: any[]) => {
                this.loadingEmploymentStatuses = false;
                this.employmentstatuses = statuses;
            });
        }

        loadElectionValues(election: any): void {
            election.electionLoading = true;
            this.electionDataProvider
                .getElection(election.elid)
                .then((electionInfo: any) => {
                    election.electionLoading = false;
                    election.values = electionInfo.values;
                });
        }

        toggleElection(election: any): void {
            if (!election.hasOwnProperty("electionLoading")) {
                this.loadElectionValues(election);
            }

            for (let i = 0; i < this.filter.elections.length; i++) {
                if (this.filter.elections[i].elid == election.elid) {
                    if (angular.isUndefined(this.filter.elections[i].checked)) {
                        this.filter.elections[i].checked = true;
                    } else {
                        if (this.readOnly) {
                            this.filter.elections[i].checked = true;
                        } else {
                            this.filter.elections[i].checked =
                                !this.filter.elections[i].checked;
                        }
                    }
                }
            }
        }

        isElectionChecked(elid: string | number): boolean {
            for (let i = 0; i < this.filter.elections.length; i++) {
                if (this.filter.elections[i].elid == elid) {
                    return this.filter.elections[i].checked;
                }
            }
        }

        toggleSurveyChecked(survey: any): void {
            if (!survey.hasOwnProperty("surveyLoading")) {
                this.loadSurvey(survey);
            }

            let found = false;
            for (let i = 0; i < this.filter.surveys.length; i++) {
                if (this.filter.surveys[i].sid == survey.sid) {
                    found = true;
                    if (angular.isUndefined(this.filter.surveys[i].checked)) {
                        this.filter.surveys[i].checked = true;
                    } else {
                        if (this.readOnly) {
                            this.filter.surveys[i].checked = true;
                        } else {
                            this.filter.surveys[i].checked =
                                !this.filter.surveys[i].checked;
                        }
                    }
                }
            }
            if (!found && angular.isDefined(survey.sid)) {
                this.filter.surveys.push({
                    sid: survey.sid,
                    checked: true,
                    questions: [],
                });
            }
        }

        //not all custom field properties need to be saved to location bar.
        isSurveyChecked(sid: string | number): boolean {
            if (this.filter.surveys) {
                for (let i = 0; i < this.filter.surveys.length; i++) {
                    if (this.filter.surveys[i].sid == sid) {
                        return this.filter.surveys[i].checked;
                    }
                }
            }
        }

        clearFilters(): void {
            this.selectedFilter = null;
            const search = this.filter.search;
            if (this.customFields) {
                for (let i = 0; i < this.customFields.length; i++) {
                    delete this.customFields[i].checked;
                    if (this.customFields[i].cftid == "1") {
                        this.customFields[i].field_val = "";
                        delete this.customFields[i]["no_value"];
                        delete this.customFields[i]["any_value"];
                    } else if (this.customFields[i].cftid == "2") {
                        delete this.customFields[i]["exact_num"];
                        delete this.customFields[i]["low_num"];
                        delete this.customFields[i]["high_num"];
                        delete this.customFields[i]["no_value"];
                        delete this.customFields[i]["any_value"];
                    } else {
                        this.customFields[i].field_val = [];
                    }
                    this.customFields[i].occupant_match = "any";
                }
            }
            this.filter.setData(_.cloneDeep(this.emptyFilter));

            angular.forEach(this.filter, (filter: any, filtername: string) => {
                if (
                    [
                        "division",
                        "income",
                        "square_footage",
                        "year_built",
                        "purchase_year",
                        "purchase_price",
                    ].includes(filtername)
                ) {
                    filter.values = {};
                    filter.checked = false;
                } else if (
                    filtername != "efforts" &&
                    filtername != "surveys" &&
                    filtername != "custom_fields" &&
                    filtername != "elections" &&
                    filter.values
                ) {
                    filter.values = [];
                    filter.checked = false;
                } else if (filtername == "surveys") {
                    angular.forEach(filter, (survey: any) => {
                        survey.checked = false;
                        survey.signature = [];
                        angular.forEach(survey.questions, (question: any) => {
                            question.answers = [];
                            question.checked = false;
                        });
                    });
                } else if (filtername == "efforts") {
                    angular.forEach(filter, (fullEffort: any, key: string) => {
                        if (key === "checked") {
                            fullEffort = false;
                            return;
                        }
                        fullEffort.checked = false;
                        fullEffort.selectedUsers = [];
                        angular.forEach(
                            fullEffort,
                            (effortFilter: any, effortKey: string) => {
                                if (effortKey === "checked") {
                                    effortFilter = false;
                                    return;
                                }

                                effortFilter.values = [];
                                effortFilter.checked = false;
                            }
                        );
                    });
                }
            });

            this.elections = undefined;
            this.setElections();
            this.filter.elections = [];
            this.filter.search = search;
            this.filter.custom_fields = this.customFields;
            this.applyFilters();
        }

        filterChanged(): boolean {
            return !angular.equals(
                this.filter.nonEmptyValues(),
                this.appliedFilter.nonEmptyValues()
            );
        }

        applyFilters(): void {
            $("#mainDataContainer").scrollTop(0);
            this.dataProvider.removeValues(this.appliedFilter);
            _.merge(this.appliedFilter, _.cloneDeep(this.filter));

            if (this.navigationBarService.smallScreen) {
                this.closeFilterBar();
            }
        }

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (user.uid == thisUser.uid) {
                    users.splice($index, 1);
                }
            });
        }
        removeTeam(team: Team, teams: Team[]): void {
            angular.forEach(teams, (thisTeam: Team, $index: number) => {
                if (team.tid == thisTeam.tid) {
                    teams.splice($index, 1);
                }
            });
        }

        isActiveDivisionCheckbox(divisionid: string | number): any {
            return this.filter.division.values[divisionid];
        }

        isActiveCampaignCheckbox(campaign: Campaign): boolean {
            return (
                this.filter.campaign.values.indexOf(campaign.campaignid) != -1
            );
        }

        toggleDivisionFilterCheckBox(division: Division): void {
            if (division.campaigns.length) {
                let campaignIDs = [];
                angular.forEach(division.campaigns, (campaign: Campaign) => {
                    campaignIDs.push(campaign.campaignid);
                });
                let index = this.filter.division.values[division.divisionid];
                if (index) {
                    delete this.filter.division.values[division.divisionid];
                } else {
                    this.filter.division.values[division.divisionid] =
                        campaignIDs;
                }
            }
        }

        toggleCampaignFilterCheckBox(campaign: Campaign): void {
            let index = this.filter.campaign.values.indexOf(
                campaign.campaignid
            );
            if (index != -1) {
                this.filter.campaign.values.splice(index, 1);
            } else {
                this.filter.campaign.values.push(campaign.campaignid);
            }
        }

        electionFilterWithID(elid: string | number, searchArray: any[]): any {
            let field = searchArray.filter((value: any) => {
                return value.elid == elid;
            });
            return field.length > 0 ? field[0] : null;
        }

        isActiveElectionFilterCheckbox(
            elid: string | number,
            value: any
        ): boolean {
            const electionField = this.electionFilterWithID(
                elid,
                this.filter.elections
            );
            return electionField.values.indexOf(value) > -1;
        }

        toggleElectionFilterCheckBox(elid: string | number, value: any): void {
            let electionField = this.electionFilterWithID(
                elid,
                this.filter.elections
            );
            let index = electionField.values.indexOf(value);
            if (index > -1) {
                electionField.values.splice(index, 1);
            } else {
                electionField.values.push(value);
            }
        }

        //surveys
        isActiveSurveyFitlerCheckbox(
            sid: string | number,
            sqid: string | number,
            answer?: any,
            signatureValue?: string | number
        ): boolean {
            let aid: string | number | undefined;
            if (answer) {
                aid = answer.atid == "3" ? answer.aname : answer.aid;
            }

            if (!this.filter || !this.filter.surveys) {
                return false;
            }

            for (let i = 0; i < this.filter.surveys.length; i++) {
                if (this.filter.surveys[i].sid == sid) {
                    if (signatureValue) {
                        if (this.filter.surveys[i].signature) {
                            return (
                                this.filter.surveys[i].signature.indexOf(
                                    signatureValue
                                ) > -1
                            );
                        }
                    } else if (
                        angular.isDefined(this.filter.surveys[i].questions)
                    ) {
                        for (
                            let j = 0;
                            j < this.filter.surveys[i].questions.length;
                            j++
                        ) {
                            if (
                                this.filter.surveys[i].questions[j].sqid == sqid
                            ) {
                                if (
                                    this.filter.surveys[i].questions[j].answers
                                ) {
                                    const index =
                                        this.filter.surveys[i].questions[
                                            j
                                        ].answers.indexOf(aid);
                                    return index > -1;
                                }
                                return false;
                            }
                        }
                    }
                }
            }

            return false;
        }

        toggleFilterItemOpen(item: any): void {
            if (!this.readOnly) {
                item.checked = !item.checked;
            }
        }

        isAnyContactFilterSelected(filter: any): boolean {
            return (
                (filter.age && filter.age.checked) ||
                (filter.age_bracket && filter.age_bracket.checked) ||
                (filter.app_type && filter.app_type.checked) ||
                (filter.campaign && filter.campaign.checked) ||
                (filter.consenttype && filter.consenttype.checked) ||
                (filter.contact_details && filter.contact_details.checked) ||
                (filter.contact_method && filter.contact_method.checked) ||
                (filter.deceased && filter.deceased.checked) ||
                (filter.division && filter.division.checked) ||
                (filter.donor && filter.donor.checked) ||
                (filter.gender && filter.gender.checked) ||
                (filter.nationbuilder_import &&
                    filter.nationbuilder_import.checked) ||
                (filter.imports && filter.imports.checked) ||
                (filter.employment_status &&
                    filter.employment_status.checked) ||
                (filter.signature && filter.signature.checked) ||
                (filter.volunteer && filter.volunteer.checked) ||
                (filter.party && filter.party.checked) ||
                (filter.group && filter.group.checked)
            );
        }

        isAnyHouseFilterSelected(filter: any): boolean {
            return (
                (filter.location_type && filter.location_type.checked) ||
                (filter.precinct && filter.precinct.checked) ||
                (filter.zipcode && filter.zipcode.checked) ||
                (filter.notes && filter.notes.checked) ||
                (filter.building && filter.building.checked) ||
                (this.readOnly && filter.street && filter.street.checked) ||
                (filter.access_type && filter.access_type.checked) ||
                (filter.building_notes && filter.building_notes.checked)
            );
        }

        toggleSurveyFilterCheckBox(
            sid: string | number,
            sqid: string | number,
            answer?: any,
            signatureValue?: string | number
        ): void {
            let aid: string | number | undefined;
            if (answer) {
                aid = answer.atid == "3" ? answer.aname : answer.aid;
            }
            let survey_found = false;
            for (let i = 0; i < this.filter.surveys.length; i++) {
                if (this.filter.surveys[i].sid == sid) {
                    survey_found = true;
                    if (signatureValue) {
                        if (!this.filter.surveys[i].signature) {
                            this.filter.surveys[i].signature = [];
                        }
                        const x =
                            this.filter.surveys[i].signature.indexOf(
                                signatureValue
                            );
                        if (x > -1) {
                            this.filter.surveys[i].signature.splice(x, 1);
                        } else {
                            this.filter.surveys[i].signature.push(
                                signatureValue
                            );
                        }
                    } else if (
                        angular.isDefined(this.filter.surveys[i].questions)
                    ) {
                        let question_found = false;
                        for (
                            let j = 0;
                            j < this.filter.surveys[i].questions.length;
                            j++
                        ) {
                            if (
                                this.filter.surveys[i].questions[j].sqid == sqid
                            ) {
                                question_found = true;
                                const index =
                                    this.filter.surveys[i].questions[
                                        j
                                    ].answers.indexOf(aid);
                                if (index > -1) {
                                    this.filter.surveys[i].questions[
                                        j
                                    ].answers.splice(index, 1);
                                } else {
                                    this.filter.surveys[i].questions[
                                        j
                                    ].answers.push(aid);
                                }
                            }
                        }
                        if (!question_found) {
                            this.filter.surveys[i].questions.push({
                                sqid: sqid,
                                atid: answer["atid"],
                                answers: [aid],
                            });
                        }
                    } else {
                        this.filter.surveys[i].questions = [
                            {
                                sqid: sqid,
                                atid: answer["atid"],
                                answers: [aid],
                            },
                        ];
                    }
                }
            }
            if (!survey_found) {
                this.filter.surveys.push({
                    sid: sid,
                    checked: true,
                    questions: [
                        {
                            sqid: sqid,
                            atid: answer["atid"],
                            answers: [aid],
                        },
                    ],
                });
            }
        }

        isActiveCustomFieldFilterCheckbox(value: any, field: Field): boolean {
            if (!field.hasOwnProperty("field_val")) field.field_val = [];
            if (field.cftid == 3 || field.cftid == 6 || field.cftid == 7) {
                return field.field_val.indexOf(value) > -1;
            }
            if (value === null) {
                return field.field_val.indexOf(value) > -1;
            }
            return field.field_val.indexOf(value.cfoid) > -1;
        }

        toggleCustomFieldFilterCheckBox(object: any, field: Field): void {
            if (this.readOnly) return;

            if (!field.hasOwnProperty("field_val")) field.field_val = [];
            let index: number, value: any;
            if (field.cftid == 3 || field.cftid == 6 || field.cftid == 7) {
                value = object;
            } else {
                if (object === null) {
                    value = null;
                } else {
                    value = object.cfoid;
                }
            }
            index = field.field_val.indexOf(value);

            if (index > -1) {
                field.field_val.splice(index, 1);
            } else {
                field.field_val.push(value);
            }
        }

        customFieldFilterWithID(
            cfid: string | number,
            searchArray: any[]
        ): any {
            let field = searchArray.filter((value: any) => {
                return value.cfid == cfid;
            });
            return field.length > 0 ? field[0] : null;
        }
        // Helper function to get filter name
        getFilterHeader(key: string): string {
            return this.filterHeaders[key] || key;
        }
        removeFilter(key: string): void {
            this.filter[key].checked = false;
        }
    },
};

angular.module("filter", []).component(FilterPane.selector, FilterPane);
